import { useMedia } from 'use-media'
import { SCREEN } from 'f-web/src/styles'

export default function useMediaMinXL() {
  const defaultState = window ? window.innerWidth >= SCREEN.XL : false
  return useMedia({ minWidth: SCREEN.XL }, defaultState)
}
